<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
import { getRefreshToken, setRefreshToken, setToken } from '@/utils/index'
import { ElMessage } from 'element-plus'
import { getCurrentInstance, onBeforeUnmount, onMounted } from 'vue'
const { proxy } = getCurrentInstance()
let timer
const setTimer = () => {
  timer = setInterval(() => {
    let refreshToken = getRefreshToken()
    let requestKey = localStorage.getItem('requestKey')
    if (refreshToken && requestKey) {
      proxy.$http
        .get('/sys/refreshTouristToken', {
          params: {
            refreshTokenParam: refreshToken,
            requestKey: requestKey
          }
        })
        .then((res) => {
          if (res.code === 0) {
            setToken(res.data.token)
            setRefreshToken(res.data.refreshToken)
          } else {
            ElMessage.error(res.msg)
          }
        })
    }
    refreshToken = null
    requestKey = null
  }, 1000 * 60 * 30)
}
onMounted(() => {
  setTimer()
})

onBeforeUnmount(() => {
  if (timer) {
    clearInterval(timer)
  }
})
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
html,
body {
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: #babbbf;
}
.scroller {
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.2);
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: #ededed;
    border-radius: 10px;
  }
}
</style>
